<template>
  <div id="app" :class="{ 'dark-mode': isDarkPage }">
    <!-- 品牌水印背景 -->
    <div class="brand-watermark" :class="{ 'is-visible': isTransitioning }">
      <div class="watermark-content">
        <img src="@/assets/img/qhy2.png" class="watermark-logo" alt="起号云 logo">
        <span class="watermark-text">{{ $siteConfig.siteName }}</span>
      </div>
    </div>

    <transition name="page-transition" mode="out-in" @before-leave="startTransition" @after-enter="endTransition">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isTransitioning: false
    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler(to) {
        // 全局捕获邀请参数（首页/登录页/注册页间切换均保留），供注册时使用
        const invite = to.query.s || to.query.upid
        if (invite) {
          window.sessionStorage.setItem('upid', invite)
        }
      }
    }
  },
  computed: {
    isDarkPage() {
      const darkPages = []
      return darkPages.includes(this.$route.path)
    }
  },
  methods: {
    startTransition() {
      this.isTransitioning = true
    },
    endTransition() {
      // ========== 这里调隐藏延迟（单位：毫秒）==========
      setTimeout(() => {
        this.isTransitioning = false
      }, 100)  // ← 改这个数字，比如 100/150/200/250
      // ================================================
    }
  }
}
</script>

<style>
/* 灰色 */
/* html {
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  -webkit-filter: grayscale(100%);
 
} */
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
.biaoqian {

  padding: 10px 0px 10px 0px;
  font-size: 13px;
  color: rgb(104, 104, 104)
}

.newdialog {
  top: -7%;
  width: 92% !important;
  max-width: 700px;
  min-width: 350px;
}

.newdialog_share {
  width: 90% !important;
  max-width: 500px;
  min-width: 350px;
}

.newdialog_dir {
  width: 90% !important;
  max-width: 900px;
  min-width: 350px;
}

.msbox {
  width: 80% !important;
  max-width: 400px !important;
}

.no-select {
  user-select: none;
  /* 标准语法 */
  -webkit-user-select: none;
  /* Safari/Chrome */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE/Edge */
}

/* ========== 页面过渡时间（改 0.2s 这个数字）========== */
.page-transition-enter-active,
.page-transition-leave-active {
  transition: opacity 0.2s ease-in-out;
  /* ← 0.2s 是过渡时长 */
}

.page-transition-enter {
  opacity: 0;
}

.page-transition-leave-to {
  opacity: 0;
}

/* 确保App容器的定位 */
#app {
  position: relative;
  width: 100%;
  height: 100vh;
  background: #f3f6fb;
}

/* 深色模式（登录/注册/首页） */
#app.dark-mode {
  background: #f3f6fb;
}

/* 品牌水印背景 */
.brand-watermark {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #f3f6fb;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  opacity: 0;
  pointer-events: none;
  /* ========== 水印淡入淡出时间（改 0.2s）========== */
  transition: opacity 0.2s ease-in-out;
  /* ← 0.2s 是淡入淡出时长 */
}

.brand-watermark.is-visible {
  opacity: 1;
}

.watermark-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  /* ========== Logo和文字出现动画时间（改 0.25s）========== */
  animation: fadeInUp 0.25s ease-out;
  /* ← 0.25s 是动画时长 */
}

.watermark-logo {
  width: 60px;
  height: 60px;
  object-fit: contain;
  filter: drop-shadow(0 8px 18px rgba(26, 115, 232, 0.2));
  animation: pulse 1.5s ease-in-out infinite;
}

.watermark-text {
  font-family: 'Hanken Grotesk', sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: #475569;
  letter-spacing: 2px;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {

  0%,
  100% {
    opacity: 0.8;
    transform: scale(1);
  }

  50% {
    opacity: 1;
    transform: scale(1.05);
  }
}

/* 针对登录注册页面的特殊过渡效果 */
.login-register-transition-enter-active,
.login-register-transition-leave-active {
  transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.login-register-transition-enter {
  opacity: 0;
  transform: translateY(20px) scale(0.95);
}

.login-register-transition-leave-to {
  opacity: 0;
  transform: translateY(-20px) scale(1.05);
}
</style>



// WEBPACK FOOTER //
// src/App.vue